import axios from "axios";

const getConfig = () => {
  return {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSRIPTION_KEY,
    },
    data: {},
  };
};

const getConfigForFiles = () => {
  return {
    headers: {
      "Content-Type": [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ],
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSRIPTION_KEY,
    },
    data: {},
  };
};

export const cdFetch = async (path: string, options = getConfig()) => {
  const response = await axios.get(
    process.env.REACT_APP_deployed_URL + path,
    options
  );
  return response; // Or handle other response types as needed
};

export const cdFetchForFiles = async (
  path: string,
  options = { ...getConfigForFiles(), responseType: "blob" as const }
) => {
  const response = await axios.get(
    process.env.REACT_APP_deployed_URL + path,
    options
  );
  return response;
};

export const cdPost = async (
  path: string,
  payload: any,
  options = getConfig()
) => {
  const response = await axios.post(
    process.env.REACT_APP_deployed_URL + path,
    payload,
    options
  );

  return response;
};
export const cdPostForFiles = async (
  path: string,
  payload: any,
  options = getConfigForFiles()
) => {
  const response = await axios.post(
    process.env.REACT_APP_deployed_URL + path,
    payload,
    options
  );

  return response;
};

// import axios, { AxiosError } from "axios";

// const SERVER_ERROR_ROUTE = "/server-error";
// const SERVER_ERROR_STATUS_CODES = [500, 503];

// const apiClient = axios.create({
//   baseURL: process.env.REACT_APP_deployed_URL,
// });

// const redirectToServerError = (error?: AxiosError) => {
//   const status = error?.response?.status;

//   if (window.location.pathname === SERVER_ERROR_ROUTE) {
//     return;
//   }

//   if (error?.code === "ERR_NETWORK") {
//     sessionStorage.setItem("apiErrorStatus", "network");
//     window.location.assign(SERVER_ERROR_ROUTE);
//     return;
//   }

//   if (!status || !SERVER_ERROR_STATUS_CODES.includes(status)) {
//     return;
//   }

//   sessionStorage.setItem("apiErrorStatus", String(status));
//   window.location.assign(SERVER_ERROR_ROUTE);
// };

// apiClient.interceptors.response.use(
//   (response) => response,
//   (error: AxiosError) => {
//     redirectToServerError(error);
//     return Promise.reject(error);
//   }
// );

// const getConfig = () => {
//   return {
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/json",
//       Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//       "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSRIPTION_KEY,
//     },
//     data: {},
//   };
// };

// const getConfigForFiles = () => {
//   return {
//     headers: {
//       "Content-Type": [
//         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//         "application/vnd.ms-excel",
//       ],
//       Accept: "application/json",
//       Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//       "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSRIPTION_KEY,
//     },
//     data: {},
//   };
// };

// export const cdFetch = async (path: string, options = getConfig()) => {
//   const response = await apiClient.get(path, options);
//   return response;
// };

// export const cdPost = async (
//   path: string,
//   payload: any,
//   options = getConfig()
// ) => {
//   const response = await apiClient.post(path, payload, options);
//   return response;
// };

// export const cdPostForFiles = async (
//   path: string,
//   payload: any,
//   options = getConfigForFiles()
// ) => {
//   const response = await apiClient.post(path, payload, options);
//   return response;
// };